(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SF-coverflow-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const RING_R = 18;
    const CIRC = 2 * Math.PI * RING_R;

    function setRing(ring, progress) {
      if (!ring) return;
      const p = Math.min(1, Math.max(0, progress));
      ring.style.strokeDasharray = String(CIRC);
      ring.style.strokeDashoffset = String(CIRC * (1 - p));
    }

    function destroyRoot(root) {
      if (!root || !root._apCoverflowSwiper) return;
      try {
        root._apCoverflowSwiper.destroy(true, true);
      } catch (e) {}
      root._apCoverflowSwiper = null;
    }

    function initRoot(root) {
      const swiperEl = root.querySelector('.ap-coverflow-slider__swiper');
      if (!swiperEl) return;

      const slideCount = parseInt(root.dataset.slideCount || '0', 10);
      if (slideCount < 1) return;

      destroyRoot(root);

      const durationMs = parseInt(root.dataset.durationMs || '12000', 10);
      const speedMs = parseInt(root.dataset.speedMs || '4000', 10);
      const autoplayOn = root.dataset.autoplay === 'true';
      const ring = root.querySelector('.ap-coverflow-slider__progress-ring');
      const progressWrap = root.querySelector('.ap-coverflow-slider__progress');

      const prevEl = root.querySelector('.ap-coverflow-slider__arrow--prev');
      const nextEl = root.querySelector('.ap-coverflow-slider__arrow--next');
      const pagEl = swiperEl.querySelector('.ap-coverflow-slider__pagination');
      const slideWidth = swiperEl.querySelector('.ap-coverflow-slider__slide').offsetWidth;
      console.log(slideWidth);

      let progressRaf = 0;
      let progressStart = 0;

      function stopProgressLoop() {
        if (progressRaf) {
          cancelAnimationFrame(progressRaf);
          progressRaf = 0;
        }
      }

      function startProgressLoop(totalMs) {
        stopProgressLoop();
        if (slideCount < 2 || !ring || !progressWrap) return;
        if (!autoplayOn) {
          setRing(ring, 0);
          return;
        }
        progressWrap.classList.remove('ap-coverflow-slider__progress--hidden');
        setRing(ring, 0);
        progressStart = performance.now();
        const total = Math.max(500, totalMs);

        function tick(now) {
          const elapsed = now - progressStart;
          const t = Math.min(1, elapsed / total);
          setRing(ring, t);
          if (t < 1) {
            progressRaf = requestAnimationFrame(tick);
          } else {
            progressRaf = 0;
          }
        }
        progressRaf = requestAnimationFrame(tick);
      }

      window.loadSwiper().then((SwiperCtor) => {
        const useLoop = slideCount > 2;
        const useRewind = slideCount > 1 && slideCount <= 3;

        const swiper = new SwiperCtor(swiperEl, {
          effect: 'creative', 
          centeredSlides: true,
          slidesPerView:'auto',
          speed: 1200,
          loop: useLoop,
          watchSlidesProgress: true,
         
          creativeEffect: {
            prev: {
              translate: [-(slideWidth -100),0, -100],
              // rotate: [0, 45, 0],
              scale: .4,
            },
            next: {
              translate: [(slideWidth -100),0, 100],
              // rotate: [0, -45, 0],
              scale: .4,
            },
          },
          navigation:
            prevEl && nextEl
              ? {
                  prevEl,
                  nextEl,
                }
              : false,
          pagination: pagEl
            ? {
                el: pagEl,
                clickable: true,
              }
            : false,
          autoplay:
            autoplayOn && slideCount > 1
              ? {
                  delay: Math.max(500, durationMs),
                  disableOnInteraction: false,
                  waitForTransition: true,
                }
              : false,
          on: {
            init() {
              if (slideCount > 1 && autoplayOn) {
                startProgressLoop(Math.max(500, durationMs));
              }
            },
            slideChangeTransitionEnd() {
              if (slideCount > 1 && autoplayOn) {
                startProgressLoop(Math.max(500, durationMs));
              }
            },
            autoplayStop() {
              stopProgressLoop();
              if (ring) setRing(ring, 0);
            },
            autoplayStart() {
              if (slideCount > 1) startProgressLoop(Math.max(500, durationMs));
            }
          },
        });

        root._apCoverflowSwiper = swiper;
      });
    }

    function initAll() {
      document.querySelectorAll('[data-ap-coverflow-root]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (ev) => {
      const r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-ap-coverflow-root]');
      if (r) initRoot(r);
    });

    document.addEventListener('shopify:section:unload', (ev) => {
      const r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-ap-coverflow-root]');
      if (r) destroyRoot(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SF-tabs-featured-collection"] && !Shopify.designMode) return;
  try {
    
  // @ts-nocheck
  class ApFeaturedCollectionTabs2 extends HTMLElement {
    constructor() {
      super();
      this._onClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.root = this.querySelector('.ap-featured-collection-tabs-2');
      if (!this.root) return;
      this.tabButtons = Array.from(this.root.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.root.querySelectorAll('[data-tab-panel]'));
      this.addEventListener('click', this._onClick);
      this.panelsContainer = this.root.querySelector('.ap-featured-collection-tabs-2__panels');

      const initiallyActive = this.root.querySelector('[data-tab-trigger].is-active');
      if (initiallyActive) {
        this.activateTab(initiallyActive.getAttribute('data-tab-id'));
      }
      const height = this.panelsContainer.getBoundingClientRect().height;
      console.log(height);
      this.panelsContainer.style.height = `${height + 48 }px`;
      this.panels.forEach((panel) => {
        panel.style.position = `absolute`;
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    activateTab(id) {
      this.tabButtons.forEach((btn) => {
        const active = btn.getAttribute('data-tab-id') === id;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-id') === id);
      });
    }

    getTrackStep(track) {
      const card = track.querySelector('.ap-featured-collection-tabs-2__card');
      if (!card) return 200;
      const styles = window.getComputedStyle(track);
      const gap = styles.columnGap || styles.gap || '0px';
      return card.getBoundingClientRect().width + parseFloat(gap);
    }

    handleClick(event) {
      const tabBtn = event.target.closest('[data-tab-trigger]');
      if (tabBtn && this.contains(tabBtn)) {
        this.activateTab(tabBtn.getAttribute('data-tab-id'));
        return;
      }

      const tabsPrev = event.target.closest('.ap-featured-collection-tabs-2__tabs-arrow--prev');
      if (tabsPrev && this.contains(tabsPrev)) {
        const tabsTrack = this.root.querySelector('.ap-featured-collection-tabs-2__tabs');
        if (tabsTrack) tabsTrack.scrollBy({ left: -220, behavior: 'smooth' });
        return;
      }

      const tabsNext = event.target.closest('.ap-featured-collection-tabs-2__tabs-arrow--next');
      if (tabsNext && this.contains(tabsNext)) {
        const tabsTrack = this.root.querySelector('.ap-featured-collection-tabs-2__tabs');
        if (tabsTrack) tabsTrack.scrollBy({ left: 220, behavior: 'smooth' });
        return;
      }

      const sliderPrev = event.target.closest('[data-slider-prev]');
      if (sliderPrev && this.contains(sliderPrev)) {
        const panel = sliderPrev.closest('[data-tab-panel]');
        const track = panel ? panel.querySelector('[data-products-track]') : null;
        if (track) track.scrollBy({ left: this.getTrackStep(track) * -1, behavior: 'smooth' });
        return;
      }

      const sliderNext = event.target.closest('[data-slider-next]');
      if (sliderNext && this.contains(sliderNext)) {
        const panel = sliderNext.closest('[data-tab-panel]');
        const track = panel ? panel.querySelector('[data-products-track]') : null;
        if (track) track.scrollBy({ left: this.getTrackStep(track), behavior: 'smooth' });
      }
    }
  }

  if (!window.customElements.get('tabs-featured-collection')) {
    window.customElements.define('tabs-featured-collection', ApFeaturedCollectionTabs2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SF-video-slider-with-link"] && !Shopify.designMode) return;
  try {
    
  window.loadSwiper().then((Swiper) => {
    console.log('Swiper initialized', Swiper);
    const swiper = new Swiper('.social-chaat-collection__content-products-carousel', {
      slidesPerView: 1.2,
      spaceBetween: 10,
      navigation: {
        nextEl: '.social-chaat-collection__content-products-carousel-navigation-button.next',
        prevEl: '.social-chaat-collection__content-products-carousel-navigation-button.previous',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
